import { IOption } from 'components/elements';
import { IAmountOptions, IServicePaymentQueryReqBody } from 'types';
import { convertUAHToCoins } from './currency';

export const getServicePaymentsServicesFromQuery = (services?: string | string[]) => {
	if (!services) return;

	try {
		if (typeof services === 'string') {
			return [JSON.parse(services)];
		}

		return services.map((service) => JSON.parse(service));
	} catch (error) {
		console.error('Error during parsing services json', error);
	}
};

export const getServicePaymentsProvidersFromQuery = (providers?: string | string[], providerId?: string) => {
	if (!providers && !providerId) return;

	if (providerId) return [providerId];

	if (typeof providers === 'string') {
		return [providers];
	}

	return providers;
};

export const getServicePaymentsMainBillFromQuery = (mainBillId?: string | string[]) => {
	if (!mainBillId) return;

	try {
		if (typeof mainBillId === 'string') {
			return [mainBillId];
		}

		return mainBillId;
	} catch (error) {
		console.error('Error during parsing mainBillId', error);
	}
};

export const getServicePaymentsAmountSumFromQuery = (amountFrom?: string, amountTo?: string) => {
	const numFrom = Number(amountFrom);
	const numTo = Number(amountTo);

	if (!numFrom && !numTo) return;

	const payload = {} as IAmountOptions;

	if (numFrom) {
		payload.gte = convertUAHToCoins(numFrom);
	}

	if (numTo) {
		payload.lte = convertUAHToCoins(numTo);
	}

	return payload;
};

export const getServicePaymentsStatusFromQuery = (status?: string | string[]) => {
	if (!status) return;

	if (typeof status === 'string') {
		return [status];
	}

	return status;
};

export const formatServicePaymentsReqBody = (reqBody: IServicePaymentQueryReqBody) => {
	const { services, serviceId, ...otherOptions } = reqBody.options;
	return {
		...reqBody,
		options: {
			...otherOptions,
			serviceId: serviceId ? [serviceId] : services?.map((item: IOption) => item.value),
		},
	};
};
